import { render, staticRenderFns } from "./CarRecommend.vue?vue&type=template&id=9057ce70"
import script from "./CarRecommend.vue?vue&type=script&lang=js"
export * from "./CarRecommend.vue?vue&type=script&lang=js"
import style0 from "./CarRecommend.vue?vue&type=style&index=0&id=9057ce70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports